const translations = {
  "en": {
    "/yr": "/yr"
  },
  "zh-tw": {
    "/yr": "/年"
  }
};

export default translations;
